import { getAvailableIntervals, INTERVAL_LABELS } from "@/utils/priceIntervals";

/**
 * Pill toggle letting a shopper pick One-off / Monthly / Annual directly on
 * a product card, per the admin's explicit choice. Renders nothing when a
 * product only offers a single interval (the common case) so existing
 * single-price products look unchanged.
 */
export default function BillingIntervalToggle({ product, value, onChange, testIdPrefix = "billing-interval" }) {
  const intervals = getAvailableIntervals(product);
  if (intervals.length <= 1) return null;
  return (
    <div
      className="inline-flex border border-border rounded overflow-hidden text-[10px]"
      role="radiogroup"
      aria-label="Billing interval"
      data-testid={`${testIdPrefix}-${product.product_id}`}
    >
      {intervals.map((iv) => (
        <button
          key={iv}
          type="button"
          role="radio"
          aria-checked={value === iv}
          onClick={(e) => { e.stopPropagation(); onChange(iv); }}
          className={`px-2 py-1 font-medium transition-colors ${
            value === iv ? "bg-primary text-primary-foreground" : "bg-background hover:bg-muted text-muted-foreground"
          }`}
          data-testid={`${testIdPrefix}-${product.product_id}-${iv}`}
        >
          {INTERVAL_LABELS[iv]}
        </button>
      ))}
    </div>
  );
}
